export { default } from './FunctionIcon';
export { FunctionIconSize } from './FunctionIcon.constants';
